// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-ce3f72de] {\n  text-align: left;\n  margin-left: 30px;\n  margin-bottom: 30px;\n}\n[data-v-ce3f72de] .message {\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n[data-v-ce3f72de] .courselist {\n  color: #222222;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n[data-v-ce3f72de] .textshow {\n  font-size: 14px;\n  color: #222222;\n  padding-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
